
import http from './http.service';

export class SearchService {

    search(filter, page = 1, perpage = 10) {
        const getCategoryFilter = (selectedCategory) => {
            if (!selectedCategory) {
                return null;
            }
            return {
                id: selectedCategory.id,
                main_category_id: selectedCategory.main_category_id || null
            };
        }

        return http.post('/search2', {
            tags: filter.tags.map(tag => tag.id),
            category: getCategoryFilter(filter.category),
            company: filter.vendor ? filter.vendor.id : null,
            type: filter.type ? filter.type.id : null,
            color: filter.color ? filter.color.id : null,
            onlyNewProduct: filter.onlyNewProduct,
            page: page,
            perpage: perpage
        })
            .then(res => res.data);
    }
}
